<script setup lang="ts">
const props = defineProps<{
  variant: PacketVariant
}>()

const { quantity, min } = inject(keys.packetQuantity)!

const prices = usePrices(props.variant)

const sum = computed(() => {
  if (prices.value === 'NOT_APPLICABLE') {
    return {
      exVat: 0,
      incVat: 0,
    }
  }

  // So we don't show negative (or otherwise stupid) sums when the user does something weird.
  const q = Math.max(quantity.value, min.value)
  return {
    exVat: q * prices.value.actual.exVat,
    incVat: q * prices.value.actual.incVat,
  }
})

const auth = useAuthorizeStore()

const hasVat = computed(() => sum.value.incVat !== sum.value.exVat)
</script>

<template>
  <div v-if="auth.isConsumer" class="text-xl">
    <span class="font-bold" v-text="norwegianPrice(sum.incVat)" />
    per tilgang per år.
  </div>
  <div v-else class="flex w-full flex-col">
    <label for="sum" class="mb-2xs">
      Total sum
    </label>
    <span class="text-xl text-blue-50">
      <output
        id="sum"
        for="quantity"
        class="font-bold"
        v-text="norwegianPrice(sum.exVat)"
      />
      <span v-if="hasVat">&nbsp;ekskl. mva.</span>
    </span>
    <span v-if="hasVat" class="text-base text-gray-40">
      <output
        id="sum"
        for="quantity"
        v-text="norwegianPrice(sum.incVat)"
      />
      inkl. mva.
    </span>
  </div>
</template>
